import * as React from "react";
import { connect } from "react-redux";
import { selectLimitedActionInfo } from "../../selectors/selectLimitedActionInfo";
import { LimitedActionType } from "../../utils/network/generated/protoTypes";
import { utilLimitedActionTime } from "../../utils/utilLimitedActionTime";
var _WaterTowerFilledStatus = function (_a) {
    var limitedActionInfo = _a.limitedActionInfo;
    if (!limitedActionInfo) {
        // tslint:disable-next-line
        return null;
    }
    var progressOfWaterCollection = utilLimitedActionTime.getLimitedActionProgress(limitedActionInfo);
    var percentageProgressOfWaterCollection = Math.floor(progressOfWaterCollection * 100) + "%";
    var expandableWaterStyle = {
        height: percentageProgressOfWaterCollection,
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "water-tower-container" },
            React.createElement("div", { className: "water-tower-container-body" }),
            React.createElement("div", { className: "water-tower-container-bottom" })),
        React.createElement("div", { className: "water-tower-container-detailing" }),
        React.createElement("div", { className: "water-tower-water" },
            React.createElement("div", { className: "water-tower-water-top" }),
            React.createElement("div", { className: "water-tower-water-middle", style: expandableWaterStyle }),
            React.createElement("div", { className: "water-tower-water-bottom" })),
        React.createElement("div", { className: "water-tower-container-roof" })));
};
var mapState = function (state) {
    var limitedActionInfo = selectLimitedActionInfo(state, LimitedActionType.WATER_TOWER);
    return {
        limitedActionInfo: limitedActionInfo,
    };
};
export var WaterTowerFilledStatus = connect(mapState)(_WaterTowerFilledStatus);



//////////////////
// WEBPACK FOOTER
// ./src/features/watertower/WaterTowerFilledStatus.tsx
// module id = 2805
// module chunks = 3